/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Toast_DeletedInputs */

const he_account_reviews_toast_deleted = /** @type {(inputs: Account_Reviews_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הביקורת נמחקה`)
};

const en_account_reviews_toast_deleted = /** @type {(inputs: Account_Reviews_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review deleted`)
};

/**
* | output |
* | --- |
* | "Review deleted" |
*
* @param {Account_Reviews_Toast_DeletedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_toast_deleted = /** @type {((inputs?: Account_Reviews_Toast_DeletedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Toast_DeletedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_toast_deleted(inputs)
	return en_account_reviews_toast_deleted(inputs)
});